<template>
    <div class="products-selector">
        <div ref="productsSortableList">
            <div class="row product-row" :data-id="getProductIdentifier(product)" v-for="(product, index) in value" :key="getProductIdentifier(product)">
                <div class="col-xs-12">
                    <a
                        v-if="showSortIcon"
                        class="change-order-by-dragging-icon text-center m-0 dragging-enabled hidden-xs"
                        href=""
                        @click.prevent=""
                    >
                        <i class="zmdi zmdi-swap-vertical"></i>
                    </a>
                    <div class="row" :class="{ 'is-dragable' : moreThanOneProductSelected }">
                        <div :class="{
                            'col-xs-8 col-sm-10': moreThanOneProductSelected && productHasAddonsAvailable(selectedProducts[index]),
                            'col-xs-10 col-sm-11': (moreThanOneProductSelected && !productHasAddonsAvailable(selectedProducts[index])) || (!moreThanOneProductSelected && productHasAddonsAvailable(selectedProducts[index])),
                            'col-xs-12': !moreThanOneProductSelected
                        }">
                            <div class="row m-b-10">
                                <div class="col-xs-12" :class="{'col-sm-6': hasVouchers && vouchersForProductId(product.product_id).length, 'col-sm-12': !hasVouchers || !vouchersForProductId(product.product_id).length}">
                                    <v-select
                                        name="product"
                                        :grouped-options="productsForVSelect"
                                        :value="selectedProducts[index].product_id"
                                        @input="onProductSelected(index, $event)"
                                        :placeholder="trans('calendar.no_product_chosen')"
                                        :templateCallback="formatState"
                                        :disabled="selectedProducts[index].can_update === false"
                                    />
                                </div>
                                <div class="col-xs-12 col-sm-6 text-italic" v-if="hasVouchers && vouchersForProductId(product.product_id).length" >
                                    <select
                                        class="form-control m-b-0 voucher-selector"
                                        :value="selectedProducts[index].client_voucher_id"
                                        @change="addProductFromVoucher($event, index)"
                                    >
                                        <option value="">{{ trans('online_booking.no_voucher_chosen') }}</option>
                                        <option v-for="voucher in vouchersForProductId(product.product_id)" :value="voucher.id" :key="voucher.id" :disabled="voucher.is_expired || !voucher.clips_left">
                                            <template v-if="voucher.is_expired">[{{ trans('client.expired').toUpperCase() }}]</template>
                                            <template v-else>{{ trans('online_booking.use_1_clip') }}</template>
                                            {{ voucher.name }} ({{ voucher.clips_left }} {{ trans('online_booking.clips_left_now') }})
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="col-xs-2 col-sm-1 p-l-0" v-if="productHasAddonsAvailable(selectedProducts[index])">
                            <button
                                v-tooltip
                                :title="trans('products.addon_tooltip')"
                                class="btn btn-default btn-icon pull-right btn-block p-r-0 p-l-0"
                                @click.prevent="addNewAddonForProduct(selectedProducts[index])"
                                :disabled="selectedProducts[index].can_update === false"
                            ><i class="zmdi zmdi-plus-circle-o-duplicate"></i></button>
                        </div>

                        <div class="col-xs-2 col-sm-1 p-l-0" v-if="moreThanOneProductSelected">
                            <button
                                class="btn btn-default btn-icon pull-right btn-block p-r-0 p-l-0 text-danger"
                                @click.prevent="removeProductAtIndex(index)"
                                :disabled="selectedProducts[index].can_update === false"
                            ><i class="zmdi zmdi-close"></i></button>
                        </div>

                        <div class="col-xs-12" v-for="(addon, addonIndex) in product.addons" :key="index + '::' + addonIndex">
                            <div class="row m-b-10">
                                <div class="col-xs-8 col-sm-10 col-xs-offset-2 col-sm-offset-1">
                                    <v-select
                                        name="product"
                                        :options="getAvailableVSelectAddons(product)"
                                        :value="product.addons[addonIndex].addon_product_id"
                                        @input="onAddonProductSelected(product, addonIndex, $event)"
                                        :placeholder="trans('calendar.no_product_chosen')"
                                        :disabled="selectedProducts[index].addons[addonIndex].can_update === false"
                                    />
                                </div>
                                <div class="col-xs-2 col-sm-1 p-l-0">
                                    <button
                                        class="btn btn-default btn-icon pull-right btn-block p-r-0 p-l-0 text-danger"
                                        @click.prevent="product.addons.splice(addonIndex, 1)"
                                        :disabled="selectedProducts[index].addons[addonIndex].can_update === false"
                                    ><i class="zmdi zmdi-close"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="!value || value.length === 0">
            <div class="col-xs-12">
                <div class="row">
                    <div :class="{'col-sm-12': !hasVouchers || !vouchersForProductId(selectedProducts[0].product_id).length, 'col-sm-6': hasVouchers && vouchersForProductId(selectedProducts[0].product_id).length}">
                        <v-select
                            name="product"
                            :grouped-options="productsForVSelect"
                            :value="selectedProducts[0].product_id"
                            @input="onProductSelected(0, $event)"
                            :placeholder="trans('calendar.no_product_chosen')"
                        />
                    </div>
                    <div class="col-sm-6" v-if="hasVouchers && vouchersForProductId(selectedProducts[0].product_id).length">
                        <select
                            class="form-control m-b-0"
                            :value="selectedProducts[0].client_voucher_id"
                            @change="addProductFromVoucher($event, 0)"
                        >
                            <option value="">{{ trans('vouchers.select_voucher_clip') }}</option>
                            <option v-for="voucher in vouchers" :value="voucher.id" :key="voucher.id" :disabled="voucher.is_expired || !voucher.clips_left">
                                <template v-if="voucher.is_expired">[{{ trans('client.expired').toUpperCase() }}]</template>
                                <template v-else>{{ trans('online_booking.use_1_clip') }}</template>
                                {{ voucher.name }} ({{ voucher.clips_left }} {{ trans('online_booking.clips_left_now') }})
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <p v-else-if="multiple && selectedProducts && selectedProducts.length && !hasAnEmptySelector" class="m-l-10">
            <a href="" @click.prevent="addAnotherProduct">
                <i class="fa-regular fa-plus"></i>
                {{ trans('products.add_another_product') }}
            </a>
        </p>
    </div>
</template>

<style lang="scss">
    .text-italic {
        font-style: italic;
    }
</style>

<script>
import VSelect from './form/VSelect';
import Sortable from 'sortablejs';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import flatten from 'lodash/flatten';
import pick from 'lodash/pick';
import Apps from "../../../core/Apps";
import forEach from "lodash/forEach";

export default {
    compatConfig: {
        WATCH_ARRAY: false,
    },
    
    name: 'ProductSelector',

    props: {
        value: {
            required: true,
            default: () => []
        },

        groupedProducts: {
            required: false,
            default: null,
        },

        clientVouchers: {
            required: false,
            default: () => [],
        },

        multiple: {
            required: false,
            default: false
        },

        allowAddons: {
            required: false,
            default: false
        },

        editMode: {
            required: false,
            default: false
        },

        showSortIcon: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            selectedProducts: [this.getNewEntryObject()],
            products_sortable: null,
            vouchers: this.clientVouchers.map(voucher => Object.assign({}, voucher)),
        }
    },

    beforeMount() {
        this.valueUpdated(this.value);
    },

    mounted() {
        this.$store.dispatch('products/loadData');

        this.$nextTick(() => {
            this.bindSortableLists();
        });
    },

    methods: {
        formatState (state) {
            if (!state.id) {
                return state.text;
            }

            // Default Color
            let serviceColor = 'transparent'

            forEach(this.productsForVSelect, (group) => {
                forEach(group.options, (option) => {
                    if (option.color && state.id == option.id) {
                        serviceColor = option.color;
                    }

                });
            });

            const $state = $('<span>');

            const textSpan = document.createElement('span');
            textSpan.textContent = state.text;
            $state.append(textSpan);

            const icon = document.createElement('i');
            icon.className = 'zmdi zmdi-circle m-l-5';
            icon.style.color = serviceColor;
            $state.append(icon);

            return $state;
        },

        bindSortableLists() {
            let vm = this;

            //Create sortable calendars wrapper
            if (this.$refs.productsSortableList) {
                this.products_sortable = Sortable.create(this.$refs.productsSortableList, {
                    group: "products",
                    handle: '.change-order-by-dragging-icon.dragging-enabled',
                    animation: 30,
                    store: {
                        get: (sortable) => {
                            return vm.selectedProducts.map(product => vm.getProductIdentifier(product));
                        },

                        set: (sortable) => {
                            vm.selectedProducts = sortable.toArray().map(id => {
                                let [bookingProductId, productId, clientVoucherId, addons] = id.split('::').map(i => i == "undefined" ? null : JSON.parse(i));
                                let selectedProduct = null;

                                if (bookingProductId > 0) {
                                    selectedProduct = find(vm.selectedProducts, {id: bookingProductId});
                                }

                                if (!selectedProduct) {
                                    selectedProduct = find(vm.selectedProducts, product => {
                                        // should have the same product ID
                                        return product.product_id == productId
                                            // the same client voucher ID
                                            && (
                                                (!clientVoucherId && product.client_voucher_id == null)
                                                || (clientVoucherId > 0 && product.client_voucher_id == clientVoucherId)
                                            )
                                            // and the same addons...
                                            && JSON.stringify(product.addons) == JSON.stringify(addons);
                                    });
                                }

                                if (!selectedProduct) {
                                    return vm.getNewEntryObject();
                                }

                                return selectedProduct;
                            });
                        }
                    }
                });
            }
        },

        getProductIdentifier(product) {
            return `${product.id}::${product.product_id}::${product.client_voucher_id}::${JSON.stringify(product.addons)}`;
        },

        onProductSelected(index, productId) {
            if (this.selectedProducts[index].user_online_payment_id === null) {
                this.selectedProducts[index].id = null;
            }

            this.assignProduct(productId, index);

            if (this.selectedProducts[index].client_voucher_id) {
                this.returnVoucherClip(this.selectedProducts[index].client_voucher_id);
                this.selectedProducts[index].client_voucher_id = null;
            }
        },

        onAddonProductSelected(bookingProduct, index, addonProductId) {
            if (bookingProduct.addons[index].user_online_payment_id === null) {
                bookingProduct.addons[index].id = null
            }

            this.assignAddonProduct(bookingProduct, addonProductId, index);
        },

        addAnotherProduct() {
            this.selectedProducts.push(this.getNewEntryObject());
        },

        removeProductAtIndex(index) {
            if (this.selectedProducts[index] && this.selectedProducts[index].client_voucher_id) {
                // add back the voucher clip
                this.returnVoucherClip(this.selectedProducts[index].client_voucher_id);
            }

            if (this.selectedProducts.length == 1) {
                this.selectedProducts = [this.getNewEntryObject()];
            } else {
                this.selectedProducts.splice(index, 1);
            }
        },

        addProductFromVoucher(event, productIndex = 0) {

            let voucher = this.getVoucher(event.target.value);

            if (!voucher && this.selectedProducts[productIndex].client_voucher_id) {
                this.returnVoucherClip(this.selectedProducts[productIndex].client_voucher_id);
                this.selectedProducts[productIndex].client_voucher_id = null;
            }

            if (voucher && voucher.clips_left && !voucher.is_expired && this.selectedProducts[productIndex]) {
                if (this.selectedProducts[productIndex].client_voucher_id) {
                    this.returnVoucherClip(this.selectedProducts[productIndex].client_voucher_id);
                }

                this.assignProduct(voucher.product_id, productIndex);
                this.selectedProducts[productIndex].client_voucher_id = voucher.id;
                this.useVoucherClip(voucher);
            }
        },

        sortByOrder(itemA, itemB) {
            if (itemA.voucher_template && itemB.voucher_template) {
                return itemA.voucher_template.order > itemB.voucher_template.order ? 1 : -1;
            }

            return 0;
        },

        vouchersForProductId(productId) {
            if (productId > 0) {
                const vouchers = [...this.vouchers.filter(voucher => voucher.product_id === productId)];
                return vouchers.sort(this.sortByOrder);
            }

            return [...this.vouchers].sort(this.sortByOrder);
        },

        getNewEntryObject() {
            return Object.assign({}, {
                id: null,
                product_id: null,
                client_voucher_id: null,
                addons: [],
                can_update: true,
            });
        },

        useVoucherClip(voucher) {
            voucher = this.getVoucher(voucher);

            if (voucher && typeof voucher == 'object') {
                voucher.clips_used++;
                voucher.clips_left--;
            }
        },

        returnVoucherClip(voucher) {
            voucher = this.getVoucher(voucher);

            if (voucher && typeof voucher == 'object') {
                voucher.clips_used--;
                voucher.clips_left++;
            }
        },

        getVoucher(voucherIdOrObject = null) {
            if (typeof voucherIdOrObject == 'number' || typeof voucherIdOrObject == 'string') {
                return find(this.vouchers, {id: parseInt(voucherIdOrObject)});
            }

            return voucherIdOrObject;
        },

        getProduct(productId = null) {
            if (parseInt(productId) > 0) {
                return find(this.flatProductList, {id: parseInt(productId)});
            }
        },

        assignProduct(product = null, index = 0) {
            if (typeof product == "number" || typeof product == "string") {
                product = this.getProduct(product);
            }

            this.selectedProducts[index].product = product;
            this.selectedProducts[index].product_id = product ? product.id : null;

            // check if the addons are still eligible for this product.
            let availableAddonIds = product && product.addons ? product.addons.map(a => a.id) : [];

            this.selectedProducts[index].addons = this.selectedProducts[index].addons.filter(addonBookingProduct => {
                return availableAddonIds.includes(addonBookingProduct.addon_product_id);
            });
        },

        assignAddonProduct(bookingProduct, addonId = null, addonIndex = 0) {
            let availableAddons = this.getAvailableAddons(bookingProduct);
            let addon = availableAddons.find(a => a.id == addonId);

            if (addon) {
                bookingProduct.addons[addonIndex].addon_product_id = addon.id;
                bookingProduct.addons[addonIndex].addon = addon;
            } else {
                bookingProduct.addons[addonIndex].addon_product_id = null;
                bookingProduct.addons[addonIndex].addon = null;
            }
        },

        emitProducts() {
            let bookingProducts = this.selectedProducts.map((bookingProduct) => {
                return Object.assign(
                    this.getNewEntryObject(),
                    {
                        id: bookingProduct.id,
                        product_id: bookingProduct.product_id,
                        product: this.getProduct(bookingProduct.product_id),
                        client_voucher_id: bookingProduct.client_voucher_id,
                        addons: bookingProduct.addons,
                        can_update: bookingProduct.can_update || !this.editMode,
                    }
                );
            });

            this.$emit('input', bookingProducts);
        },

        productHasAddonsAvailable(selectedProduct) {
            return this.allowAddons && selectedProduct.product && selectedProduct.product.addons && selectedProduct.product.addons.length > 0;
        },

        addNewAddonForProduct(bookingProduct) {
            bookingProduct.addons.push({
                id: null,
                addon_product_id: null,
                addon: null
            });
        },

        getAvailableAddons(bookingProduct) {
            let product = this.getProduct(bookingProduct.product_id);

            if (product && product.addons && product.addons.length > 0) {
                return product.addons;
            }

            return [];
        },

        getAvailableVSelectAddons(bookingProduct) {
            return this.getAvailableAddons(bookingProduct).map(addon => {
                return {
                    id: addon.id,
                    label: `${addon.name}` + (addon.time !== '0' ? ` (+ ${addon.time_formatted})` : ``),
                };
            });
        },

        valueUpdated(newProducts) {
            var vm = this;

            for (var i = 0; i < newProducts.length; i++) {
                if (newProducts[i] && newProducts[i].product_id == null && (vm.selectedProducts[i].product_id == undefined || vm.selectedProducts[i].product_id == null) && newProducts.length == vm.selectedProducts.length) {
                    continue;
                }

                if (newProducts[i] && newProducts[i].product_id && vm.selectedProducts[i].product_id == newProducts[i].product_id && newProducts.length == vm.selectedProducts.length) {
                    continue;
                }

                vm.selectedProducts = newProducts.map(bookingProduct => {
                    return {
                        id: bookingProduct.id,
                        product_id: bookingProduct.product_id,
                        product: this.getProduct(bookingProduct.product_id),
                        client_voucher_id: bookingProduct.client_voucher_id,
                        addons: bookingProduct.addons ? bookingProduct.addons.map(addonBookingProduct => {
                            return {
                                id: addonBookingProduct.id,
                                addon_product_id: addonBookingProduct.addon_product_id,
                                addon: this.getAvailableAddons(bookingProduct).find(a => a.id == addonBookingProduct.addon_product_id),
                                can_update: addonBookingProduct.can_update || !this.editMode,
                            }
                        }) : [],
                        can_update: bookingProduct.can_update || !this.editMode,
                    };
                });

                // we have set all the products already, quit the loop.
                return;
            }

            if (!newProducts || newProducts.length == 0) {
                vm.selectedProducts = [this.getNewEntryObject()];
            }
        },

        isEmpty: isEmpty,

        find: find,
    },

    watch: {
        selectedProducts: {
            handler: function (newBookingProducts, oldIds) {
                this.emitProducts();
            },
            deep: true
        },

        value: {
            handler: function (newProducts) {
                this.valueUpdated(newProducts);
            },
            deep: true,
        },

        clientVouchers: {
            handler(newVouchers) {
                this.vouchers = newVouchers.map(voucher => Object.assign({}, voucher));
            },
            deep: true
        }
    },

    computed: {
        groupedProductsFinal() {
            return this.groupedProducts ? this.groupedProducts : this.$store.getters['products/getOrderedProductGroups']();
        },

        productsForVSelect() {
            return this.groupedProductsFinal.map(group => {
                return {
                    label: group.name,
                    options: group.products.map(p => {
                        return {
                            id: p.id,
                            label: `${p.name} (${p.time_formatted})`,
                            color: p.color
                        };
                    })
                };
            });
        },

        flatProductList() {
            return flatten(this.groupedProductsFinal.map(group => {
                return group.products;
            }));
        },

        hasAnEmptySelector() {
            return find(this.selectedProducts, {product_id: null}) !== undefined;
        },

        moreThanOneProductSelected() {
            return this.selectedProducts && this.selectedProducts.length > 1;
        },

        is_vouchers_app_enabled() {
            return this.$store.getters['apps/isAppEnabled'](Apps.Vouchers);
        },

        hasVouchers() {
            return this.is_vouchers_app_enabled && this.vouchers && this.vouchers.length > 0;
        }
    },

    components: {
        VSelect,
    }
}
</script>
